import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove
    , setListModelo
    , setValidations
} from '../redux/therapyPlanAreaSlice'
import AutocompleteRegistro from './AutocompleteRegistro'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';

const TherapyPlanArea = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.therapyPlanArea.entity)
    const defaultEntity = useSelector((state) => state.therapyPlanArea.defaultEntity)
    const listModelo = useSelector((state) => state.therapyPlanArea.listModelo)
    // Escalas de la cabecera del plan (planificacion y avance): alimentan
    // los grupos de puntuacion del detalle de areas.
    const idPuntuacionPlanificacion = useSelector((state) => state.therapyPlan.entity.idPuntuacionPlanificacion);
    const idPuntuacionAvance = useSelector((state) => state.therapyPlan.entity.idPuntuacionAvance);
    const [listPuntuacionGrupo, setListPuntuacionGrupo] = useState([]);
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const validate = useSelector((state) => state.therapyPlanArea.validationActive);
    const dispatch = useDispatch();

    // El detalle de areas en el plan es opcional (no se exige tener al menos una fila).
    var validation = {}

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    const fetchModelo = useCallback(async () => {
        const response = await api.get("/Modelo/GetsModelo")
            .catch((err) => {
                console.log("Err: ", err);
            });

        // Si la peticion falla el catch devuelve undefined: con ?. no se
        // revienta la pantalla, el combo queda vacio.
        dispatch(setListModelo(response?.data?.data || []));
    }, [dispatch])

    const setArea = useCallback(async (idModelo, numero) => {
        if (!idModelo || idModelo <= 0) {
            setItemValue(numero, "modeloArea", [])
            return;
        }
        const response = await api.get("/Modelo/GetsArea?idModelo=" + idModelo)
            .catch((err) => {
                console.log("Err: ", err);
            });
        setItemValue(numero, "modeloArea", response?.data?.data || [])
    }, [])

    // Busca areas del modelo en el servidor (autocompletado del Area).
    const buscarArea = useCallback(async (idModelo, texto) => {
        if (!idModelo || idModelo <= 0) return [];
        const response = await api.get("/Modelo/BuscarArea?idModelo=" + idModelo
            + "&texto=" + encodeURIComponent(texto))
            .catch((err) => { console.log("Err: ", err); return { data: { data: [] } }; });
        return response?.data?.data || [];
    }, [])

    // Registra un area nueva dentro del modelo y recarga su listado.
    const registrarArea = useCallback(async (idModelo, texto, numero) => {
        if (!idModelo || idModelo <= 0) return null;
        const response = await api.post("/Modelo/AddUpdateArea", {
            idModelo: idModelo, codigo: "", nombre: texto, descripcion: "", orden: 0
        })
        const id = response?.data?.data || 0;
        if (id > 0) await setArea(idModelo, numero);
        return { id: id, nombre: texto };
    }, [setArea])

    // Al cargar el plan las areas de cada modelo no vienen en la vista, asi que se
    // piden para que el combo de Areas muestre sus opciones.
    const cargarAreas = useCallback(async (rows) => {
        for (const row of rows) {
            if (row.idModelo > 0 && (!row.modeloArea || row.modeloArea.length == 0)) {
                await setArea(row.idModelo, row.numero);
            }
        }
    }, [setArea])

    // Los grupos de puntuacion dependen de la escala seleccionada en la cabecera.
    const fetchPuntuacionGrupo = useCallback(async (idPlanif, idAvance) => {
        let grupos = [];

        // 1. Escala de planificacion de la cabecera
        if (idPlanif && idPlanif > 0) {
            const resp = await api.get("/Puntuacion/GetsPuntuacionGrupoPorPuntuacion?idPuntuacion=" + idPlanif)
                .catch((err) => { console.log("Err: ", err); });
            grupos = resp?.data?.data || [];
        }

        // 2. Si la escala de planificacion no tiene grupos o no esta seleccionada,
        // consulta la escala de avance
        if (grupos.length === 0 && idAvance && idAvance > 0) {
            const resp = await api.get("/Puntuacion/GetsPuntuacionGrupoPorPuntuacion?idPuntuacion=" + idAvance)
                .catch((err) => { console.log("Err: ", err); });
            grupos = resp?.data?.data || [];
        }

        // 3. Fallback: Si no tiene grupos especificos o aun no se define escala en cabecera,
        // trae los grupos del sistema para que el desplegable no quede vacio
        if (grupos.length === 0) {
            const resp = await api.get("/Puntuacion/GetsPuntuacionGrupo")
                .catch((err) => { console.log("Err: ", err); });
            grupos = resp?.data?.data || [];
        }

        setListPuntuacionGrupo(grupos);
    }, [])

    const fecthEntity = useCallback(async () => {
        if (!params.id || params.id === "0" || params.id == 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        const response = await api.get("/TerapiaPlan/GetsTerapiaPlanAreaView?idTerapiaPlan=" + params.id)
            .then((response) => {
                if (response.data.data == null || response.data.data.length == 0){
                    dispatch(setEntity(defaultEntity));
                }
                else {
                    dispatch(setEntity(response.data.data));

                    // Las areas del modelo de cada fila no vienen en la vista.
                    cargarAreas(response.data.data);
                }
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }, [params.id, defaultEntity, dispatch, cargarAreas])

    useEffect(() => {
        const idPlanif = idPuntuacionPlanificacion > 0
            ? idPuntuacionPlanificacion
            : (entity && entity.length > 0 && entity[0].idPuntuacionPlanificacion > 0 ? entity[0].idPuntuacionPlanificacion : 0);
        const idAvance = idPuntuacionAvance > 0
            ? idPuntuacionAvance
            : (entity && entity.length > 0 && entity[0].idPuntuacionAvance > 0 ? entity[0].idPuntuacionAvance : 0);

        fetchPuntuacionGrupo(idPlanif, idAvance);
    }, [idPuntuacionPlanificacion, idPuntuacionAvance, entity, fetchPuntuacionGrupo])

    useEffect(() => {
        fecthEntity();
    }, [fecthEntity]);

    useEffect(() => {
        fetchModelo();
    }, [fetchModelo]);

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        await api.delete("/TerapiaPlan/DeleteTerapiaPlanArea?idTerapiaPlan="
                + params.id + "&numero=" + selectNumero)
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(remove(selectNumero));
    }
 
    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        {"Areas (" + (entity?.length || 0) + ")"}
                    </Typography>
                </Box>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Area" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(entity)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        {/* El modelo es obligatorio en la fila del detalle; el
                                            area es opcional. */}
                                        <Grid item xs={12} sm={3}>
                                            <FormControl required fullWidth>
                                                <InputLabel shrink htmlFor="input-modelo">Modelo</InputLabel>
                                                <Select
                                                    native
                                                    label="Modelo"
                                                    value={row.idModelo}
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;
                                                        
                                                        setItemValue(row.numero, "idModelo", event.target.value)
                                                        setItemValue(row.numero, "modelo", event.nativeEvent.target[id].text)

                                                        if (event.target.value != null) {
                                                            setArea(event.target.value, row.numero)
                                                        }
                                                    }}
                                                    inputProps={{
                                                        name: 'idModelo',
                                                        id: 'input-modelo',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listModelo.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.nombre}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {/* El Area lleva el texto mas largo (nombre del
                                            area), asi que toma el espacio que sobra
                                            de la fila: a tamano medio se lleva la
                                            mitad. */}
                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth>
                                                {/* El Area es opcional y acepta texto libre: si se escribe un
                                                    nombre que no esta entre las areas del modelo,
                                                    aparece el boton 'Registrar Nuevo' fijo al
                                                    final del desplegable y se registra al
                                                    confirmarlo. */}
                                                <AutocompleteRegistro
                                                    label="Area"
                                                    name="idArea"
                                                    disabled={isReadOnly}
                                                    texto={row.area}
                                                    idSeleccionado={row.idArea}
                                                    opciones={row.modeloArea || []}
                                                    getLabel={(opcion) => opcion.nombre}
                                                    onTexto={(t) => setItemValue(row.numero, "area", t)}
                                                    onSeleccionar={(area) => {
                                                        const id = (area != null && area.id > 0) ? area.id : 0;
                                                        setItemValue(row.numero, "idArea", id);
                                                        setItemValue(row.numero, "area", area != null ? (area.nombre || "") : "");
                                                    }}
                                                    onBuscar={(texto) => buscarArea(row.idModelo, texto)}
                                                    onRegistrarNuevo={(texto) => registrarArea(row.idModelo, texto, row.numero)}
                                                    puedeRegistrar={row.idModelo > 0}
                                                    mensajeFaltaPadre="Seleccione primero el Modelo."
                                                    tipoRegistro="area"
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Orden: el campo es angosto, asi que
                                             necesita ancho propio para que se vea
                                             el numero (y las flechitas del input
                                             number) sin cortarse. */}
                                        <Grid item xs={4} sm={1.5}>
                                            <TextField
                                                required
                                                name="orden"
                                                label="Orden"
                                                type="number"
                                                value={row.orden}
                                                fullWidth
                                                onChange={(event) => {
                                                    setItemValue(row.numero, "orden", event.target.value)
                                                }}
                                                disabled={isReadOnly}
                                                size="small"
                                                inputProps={{
                                                    style: { paddingRight: "4px", paddingLeft: "8px" },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={2.5}>
                                            <FormControl fullWidth>
                                                <InputLabel shrink htmlFor={"input-grupo-" + row.numero}>Grupo puntuacion</InputLabel>
                                                <Select
                                                    native
                                                    label="Grupo puntuacion"
                                                    value={row.idPuntuacionGrupo == null ? 0 : row.idPuntuacionGrupo}
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idPuntuacionGrupo", event.target.value == 0 ? null : event.target.value)
                                                        setItemValue(row.numero, "puntuacionGrupo", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idPuntuacionGrupo',
                                                        id: 'input-grupo-' + row.numero,
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {row.idPuntuacionGrupo > 0 && !listPuntuacionGrupo.some((childrow) => String(childrow.id) === String(row.idPuntuacionGrupo)) && (
                                                        <option key={row.idPuntuacionGrupo} value={row.idPuntuacionGrupo}>
                                                            {row.puntuacionGrupo || `Grupo #${row.idPuntuacionGrupo}`}
                                                        </option>
                                                    )}
                                                    {listPuntuacionGrupo.map((childrow) => (
                                                        <option key={childrow.id} value={childrow.id}>{childrow.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={2} sm={1}>
                                            <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar area"}
                texto={"Esta seguro de borrar el area?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default TherapyPlanArea;
